import {
  Badge,
  Box,
  Flex,
  Grid,
  GridItem,
  Link,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";

import { AdminMemberActions } from "@/admin/components/AdminMemberActions";
import { useAdminMembers } from "@/admin/data/useAdminMembers";
import { Avatar } from "@/common/components/Avatar";
import TimestampCell from "@/common/components/TimestampCell";
import { MemberRoleBadge } from "@/global-settings/components/MemberRoleBadge";
import { Org } from "@reflag/shared/organizationAPI";

export default function AdminOrgMembers({
  org,
}: {
  org: Pick<Org, "id" | "name">;
}) {
  const { data = [], isLoading } = useAdminMembers(org.id);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Role</Th>
          <Th>Signed up</Th>
          <Th>Joined</Th>
          <Th></Th>
        </Tr>
      </Thead>
      <Tbody>
        {data.map((member) => (
          <Tr key={member.id}>
            <Td>
              <Grid
                columnGap={3}
                rowGap={0.5}
                templateColumns="min-content 1fr"
              >
                <GridItem rowSpan={2}>
                  <Avatar
                    key={`${member.id}-${member.avatarUrl}`}
                    display="flex"
                    name={member.name}
                    size="md"
                    src={member.avatarUrl ?? undefined}
                  />
                </GridItem>
                <GridItem as={Flex}>
                  <Text>{member.name}</Text>
                  <Box>
                    {member.isReflagAdmin ? <Badge mx="2">Reflag</Badge> : null}
                  </Box>
                </GridItem>
                <GridItem>
                  <Link color="dimmed" href={`mailto:${member.email}`}>
                    {member.email}
                  </Link>
                </GridItem>
              </Grid>
            </Td>
            <Td>
              <MemberRoleBadge role={member.role} />
            </Td>
            <Td>
              <TimestampCell value={member.signedUpAt} />
            </Td>
            <Td>
              <TimestampCell value={member.joinedAt} />
            </Td>
            <Td textAlign="right">
              <AdminMemberActions member={member} org={org} />
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
